import React from "react";
import { Link } from "react-router-dom";
import { Eye, Gavel, Heart, Flame } from "lucide-react";
import Countdown from "../components/Countdown";
import { inr, resolveImg } from "../lib/api";
import { Est } from "../lib/currency";

export default function AuctionCard({ listing }) {
  const currentBid = listing.current_bid || listing.starting_bid;
  const ending = new Date(listing.ends_at).getTime() - Date.now() < 1000 * 60 * 60; // <1h
  return (
    <Link
      to={`/auction/${listing.id}`}
      data-testid="auction-card"
      className="group relative flex flex-col bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 rounded-2xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden"
    >
      <div className="relative aspect-[4/3] bg-slate-100 dark:bg-slate-800 overflow-hidden">
        {listing.promoted && (
          <span data-testid="promoted-badge" className="absolute top-3 right-3 z-10 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-amber-500 text-slate-900 text-[10px] font-bold uppercase tracking-wider shadow-md">
            Promoted
          </span>
        )}
        {listing.photos?.[0] ? (
          <img src={resolveImg(listing.photos[0])} alt={listing.title}
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-slate-400"><Gavel className="h-10 w-10" /></div>
        )}
        {listing.featured && (
          <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-amber-500 text-slate-900 text-[10px] font-bold uppercase tracking-wider">
            Featured
          </span>
        )}
        {ending && listing.status === "live" && (
          <span className="absolute top-3 right-3 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-red-600 text-white text-[10px] font-bold animate-pulse">
            <Flame className="h-3 w-3" /> ENDING SOON
          </span>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-amber-600 dark:text-amber-400 mb-1">
          {listing.category_name}
        </div>
        <h4 className="font-semibold text-slate-900 dark:text-slate-100 line-clamp-2 leading-tight text-sm sm:text-base">
          {listing.title}
        </h4>
        <div className="mt-3 flex items-end justify-between">
          <div>
            <div className="text-[10px] uppercase text-slate-500 font-semibold">Current Bid</div>
            <div data-testid="auction-current-bid" className="text-lg font-extrabold text-slate-900 dark:text-white">
              {inr(currentBid)}
            </div>
            <Est inr={currentBid} className="text-slate-500 block" />
          </div>
          <div className="text-right">
            <Countdown endsAt={listing.ends_at} small />
            <div className="text-[10px] text-slate-500 mt-0.5">{listing.bid_count} bids</div>
          </div>
        </div>
        <div className="flex items-center gap-3 mt-3 text-[11px] text-slate-500">
          <span className="inline-flex items-center gap-1"><Eye className="h-3 w-3" /> {listing.views}</span>
          <span className="inline-flex items-center gap-1"><Heart className="h-3 w-3" /> {listing.watchers}</span>
          <span className="ml-auto truncate max-w-[100px]">{listing.seller_name}</span>
        </div>
      </div>
    </Link>
  );
}
